import { useEffect } from "react"
import Rollbar from "rollbar"
import Link from "next/link"

export default function ErrorPage(props) {
  
  useEffect(() => {
    
    try {
      
      const rollbarConfig = {
        enabled: process.env.NODE_ENV != 'development',
        accessToken: process.env.NEXT_PUBLIC_ROLLBAR_ACCESS_TOKEN,
        payload: {
          environment: process.env.NEXT_PUBLIC_ROLLBAR_ENV,
          client: {
            javascript: {
              source_map_enabled: true,
              code_version: process.env.NEXT_PUBLIC_VERSION,
              guess_uncaught_frames: true
            }
          },
          server: {
            // root: "https://" + props.site.domain + "/",
            branch: process.env.NODE_ENV == 'production' ? "main" : "dev",
          },
          code_version: process.env.NEXT_PUBLIC_VERSION,
        },
        captureUncaught: true,
        captureUnhandledRejections: true,
      }
    
      const rollbar = new Rollbar(rollbarConfig)
      rollbar.error(props.error)
      
    } catch (e) {
    }
  
    
  }, [])
  
  return (
    <html>
      <body>
        <main className="page">
          <section>
            <h1>Something went wrong!</h1>
          </section>
          <section>
            <div className="flex-row flex-with-gap flex-wrapped">
              <Link href="/">Home</Link>
              <Link href="/vehicles">Shop</Link>
            </div>
          </section>
          { props.error.digest &&
          <section>
            ({ props.error.digest })
          </section>
          }
        </main>
      </body>
    </html>
  )
  
  
}